var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-popover",
    {
      attrs: {
        placement: "bottomRight",
        overlayClassName: "avatar-popover-overlay",
        trigger: ["hover"],
      },
      on: { visibleChange: _vm.visibleChange },
      model: {
        value: _vm.visible,
        callback: function ($$v) {
          _vm.visible = $$v
        },
        expression: "visible",
      },
    },
    [
      _c(
        "template",
        { slot: "content" },
        [
          _c(
            "div",
            {
              staticStyle: {
                "min-width": "200px",
                padding: "15px 12px",
                display: "flex",
                "align-items": "center",
              },
              style: _vm.note,
            },
            [
              _vm.userInfo
                ? _c(
                    "div",
                    {
                      staticStyle: {
                        "margin-right": "10px",
                        "border-radius": "50%",
                        width: "32px",
                        height: "32px",
                        "font-size": "20px",
                        "text-align": "center",
                        overflow: "hidden",
                      },
                      style: {
                        background: !_vm.userInfo.headImgUrl
                          ? "#d1d1d1"
                          : "#fff",
                      },
                    },
                    [
                      !_vm.userInfo.headImgUrl
                        ? _c("icon-font", {
                            staticClass: "gb-icon-user",
                            staticStyle: { color: "#fff" },
                            attrs: { type: "gb-icon-user" },
                          })
                        : _c("img", {
                            staticStyle: {
                              width: "32px",
                              height: "32px",
                              display: "block",
                            },
                            attrs: { src: _vm.userInfo.headImgUrl },
                          }),
                    ],
                    1
                  )
                : _vm._e(),
              _c("div", { staticStyle: { flex: "1", "min-width": "0" } }, [
                _c(
                  "div",
                  {
                    staticStyle: {
                      color: "#1E1E28",
                      "font-size": "14px",
                      "font-weight": "bold",
                    },
                  },
                  [_vm._v(_vm._s(_vm._f("userName")(_vm.userInfo)))]
                ),
                _c(
                  "div",
                  {
                    staticStyle: {
                      color: "#484848",
                      "font-size": "12px",
                      display: "flex",
                      "align-items": "center",
                    },
                  },
                  [
                    _c(
                      "div",
                      { staticStyle: { flex: "1", "min-width": "0" } },
                      [_vm._v(_vm._s(_vm.packageName))]
                    ),
                  ]
                ),
              ]),
            ]
          ),
          _c(
            "a-menu",
            {
              attrs: {
                mode: "vertical",
                selectable: false,
                openKeys: _vm.openKeys,
              },
              on: {
                "update:openKeys": function ($event) {
                  _vm.openKeys = $event
                },
                "update:open-keys": function ($event) {
                  _vm.openKeys = $event
                },
                click: _vm.handleMenuClick,
                openChange: _vm.handleSubMenuOpenChange,
                mousemove: _vm.handleSubMenuMove,
              },
            },
            [
              _c(
                "a-menu-item",
                { key: "logout" },
                [
                  _c("icon-font", {
                    staticClass: "iconFont",
                    attrs: { type: "gb-icon-a-05" },
                  }),
                  _c("div", [_vm._v(_vm._s(_vm.i18nRender("layouts.logout")))]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "right-content__action" },
        [
          !_vm.userInfo.headImgUrl
            ? _c("icon-font", {
                staticClass: "gb-icon-user",
                attrs: { type: "gb-icon-user" },
              })
            : _c("img", {
                staticStyle: {
                  width: "22px",
                  height: "22px",
                  "border-radius": "50%",
                  background: "#fff",
                },
                attrs: { src: _vm.userInfo.headImgUrl },
              }),
          _c("span", { staticStyle: { "margin-left": "8px" } }, [
            _vm._v(_vm._s(_vm._f("userName")(_vm.userInfo))),
          ]),
          _c("icon-font", {
            staticStyle: { "margin-left": "10px" },
            attrs: { type: "gb-icon-Down" },
          }),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }